module.exports = __webpack_public_path__ + "img/Cuidando_tu_salud.0ad0d055.svg";